import React from 'react';
import SplitSection from '../common/split-section';
import StatsCardsGrid from './stats-cards-grid';
import { NumbersDontLieSectionProps } from '../types';

const NumbersDontLieSection: React.FC<NumbersDontLieSectionProps> = ({
  leftCards,
  rightCards,
}) => {
  return (
    <section className="py-8 xl:my-24 md:my-24 wg-container">
      <div className="flex items-center sm:flex-col">
        <SplitSection
          heading="Numbers don't lie!"
          description="Products that perform seamlessly during any kind of surge, so you don't have to worry about uptime and reliability. Ingest and process any amount of data any time of the month, smoothly."
          classname="items-center sm:block"
          headingClasses="text-left mx-0 max-w-none w-5/12 pr-16 md:pr-10 sm:w-full sm:pr-0"
          child={
            <StatsCardsGrid leftCards={leftCards} rightCards={rightCards} />
          }
        />
      </div>
    </section>
  );
};

export default NumbersDontLieSection;
